module.exports = __webpack_public_path__ + "img/contact-info-row-white.6c549887.png";